<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="data.model.dataDesejadaProcedimentosCirurgicos"
            sort-by="nome"
        >
            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    @click="destroy(item)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>
    </div>
</template>

<script>
// Mixins.
import { formats } from '@/mixins'

export default {
    data() {

        return {
            fields: [
                {
                    key: 'codigo',
                    label: 'Código',
                    formatter: codigo => this.formatProcedimento(codigo),
                    sortable: true,
                    class: 'col-min',
                },
                { key: 'nome', label: 'Nome', sortable: true },
                { key: 'actions', label: 'Ações', class: 'col-min text-center' },
            ],
        }
    },
    methods: {
        destroy(procedimento) {

            this.showDeleteConfirmation(
                'Deseja realmente excluir o procedimento cirúrgico?',
                async () => this.data.model.dataDesejadaProcedimentosCirurgicos
                    .splice(this.data.model.dataDesejadaProcedimentosCirurgicos.indexOf(procedimento), 1)
            )
        }
    },
    mixins: [formats],
    props: {
        data: { type: Object, required: true },
    }
}
</script>